import React, { useEffect } from "react";
import { Route, Routes, Link } from "react-router-dom";
import AddInstructor from "../components/AddInstructor/addInstructor";
import AddTrainingCenterForm from "../components/AddTrainingCentreForm/addTrainingCentreForm";
import FeedBackChart from "../components/FeedBackChart";
import FeedBackDetails from "../components/FeedBackDetails";
import FeedBackListing from "../components/FeedBackListing";
import LongTermMachineList from "../components/LongTermMachine/longTermMachineList";
import TrainingListing from "../components/TrainingListing/index";
import TrainingListingDetails from "../components/TraininglistingDetails";
import Veyon from "../components/Veyon/veyon";
import { APP_ROUTES } from "../globals/constants";
import TraingCenter from "../pages/TrainingCenterModule";
import TCAdmin from "../pages/TCAdminModule";
import AddTCAdminForm from "../components/AddTCAdminForm/addTCAdminForm";
import Instructor from "../pages/InstrutorModule";
import Student from "../pages/StudentModule";
import DashboardModule from "../pages/DashBoardModule";
import LoginModule from "../pages/LoginModule";
import ImageConfigurator from "../pages/ImageConfigurator";
import CreateSession from "../pages/CreateSession";
import EmailTemplateList from "../pages/Email";
import EmailTemplate from "../components/EmailTemplate/EmailTemplate";
import CreateFeedback from "../components/CreateFeedback/index";
import FillFeedback from "../components/FillFeedback";
import ProtectedRoute from "../components/ProtectedRoute";
import { ROLE } from "../globals/constants/index";
import FeedbackTemplate from "../components/feedbackTemplate/FeedbackTemplate";
import CallBack from "../components/CallBack";
import AddStudent from "../components/AddStudent/addStudent";
import Reports from "../pages/Reports";
import CONTACTSUPPORT from "../pages/ContactSupp/contactSupport";
import MONITORING from "../pages/Monitoring";
import { ErrorBoundary } from "react-error-boundary";
import ErrorPage from "../pages/ErrorPage";
import Error from "../Images/404.svg";
import DataNotFound from "../pages/DataNotFound";
const MainRoutes = () => {
  return (
    <>
      <Routes>
        <Route path={APP_ROUTES.ERROR} element={<DataNotFound />}></Route>
        <Route path={APP_ROUTES.CALLBACK} element={<CallBack />}></Route>
        <Route path={APP_ROUTES.ROUTE_LOGIN} element={<LoginModule />}></Route>
        <Route
          path={APP_ROUTES.ROUTE_ADMIN_LOGIN}
          element={<LoginModule />}
        ></Route>
        <Route element={<ProtectedRoute allowedRoles={[ROLE.STUDIO_ADMIN]} />}>
          <Route
            path={APP_ROUTES.ROUTE_ROOT}
            element={<DashboardModule />}
          ></Route>
        </Route>
        <Route element={<ProtectedRoute allowedRoles={[ROLE.STUDIO_ADMIN]} />}>
          <Route path={APP_ROUTES.ADD_STUDENT} element={<AddStudent />}></Route>
        </Route>
        <Route
          element={
            <ProtectedRoute allowedRoles={[ROLE.ADMIN, ROLE.STUDIO_ADMIN]} />
          }
        >
          <Route
            path={APP_ROUTES.ROUTE_EMAILTEMPLATE}
            element={<EmailTemplate />}
          ></Route>
        </Route>
        <Route
          element={
            <ProtectedRoute allowedRoles={[ROLE.ADMIN, ROLE.STUDIO_ADMIN]} />
          }
        >
          <Route
            path={APP_ROUTES.ROUTE_EMAILTEMPLATELIST}
            element={<EmailTemplateList />}
          ></Route>
        </Route>
        <Route element={<ProtectedRoute allowedRoles={[ROLE.STUDIO_ADMIN]} />}>
          <Route
            path={APP_ROUTES.ROUTE_IMAGECONFIGURATOR}
            element={<ImageConfigurator />}
          ></Route>
        </Route>
        <Route
          element={
            <ProtectedRoute
              allowedRoles={[ROLE.STUDIO_ADMIN, ROLE.INSTRUCTOR]}
            />
          }
        >
          <Route
            path={APP_ROUTES.ROUTE_CREATESESSION}
            element={<CreateSession />}
          ></Route>
        </Route>
        <Route element={<ProtectedRoute allowedRoles={[ROLE.STUDIO_ADMIN]} />}>
          <Route
            path={APP_ROUTES.ADD_INSTRUCTOR}
            element={<AddInstructor />}
          ></Route>
        </Route>
        <Route
          element={
            <ProtectedRoute
              allowedRoles={[ROLE.STUDIO_ADMIN, ROLE.INSTRUCTOR]}
            />
          }
        >
          <Route
            path={APP_ROUTES.LONGTERMMACHINE}
            element={<LongTermMachineList />}
          ></Route>
        </Route>
        <Route
          element={
            <ProtectedRoute
              allowedRoles={[ROLE.STUDIO_ADMIN, ROLE.INSTRUCTOR]}
            />
          }
        >
          <Route path={APP_ROUTES.VEYON} element={<Veyon />}></Route>
        </Route>
        <Route element={<ProtectedRoute allowedRoles={[ROLE.ADMIN]} />}>
          <Route
            path={APP_ROUTES.ADD_TRAINING_CENTRE}
            element={<AddTrainingCenterForm />}
          ></Route>
        </Route>
        <Route
          element={
            <ProtectedRoute
              allowedRoles={[ROLE.INSTRUCTOR, ROLE.STUDIO_ADMIN, ROLE.STUDENT]}
            />
          }
        >
          <Route
            path={APP_ROUTES.TRAINING_LISTING}
            element={<TrainingListing />}
          ></Route>
        </Route>
        <Route
          element={
            <ProtectedRoute
              allowedRoles={[ROLE.INSTRUCTOR, ROLE.STUDIO_ADMIN]}
            />
          }
        >
          <Route
            path={APP_ROUTES.TRAINING_LISTING_DETAILS}
            element={<TrainingListingDetails />}
          ></Route>
        </Route>
        <Route
          element={
            <ProtectedRoute
              allowedRoles={[ROLE.INSTRUCTOR, ROLE.STUDIO_ADMIN]}
            />
          }
        >
          <Route
            path={APP_ROUTES.FEEDBACK_LISTING}
            element={<FeedBackListing />}
          ></Route>
        </Route>
        <Route
          element={
            <ProtectedRoute
              allowedRoles={[ROLE.INSTRUCTOR, ROLE.STUDIO_ADMIN, ROLE.STUDENT]}
            />
          }
        ></Route>
        <Route
          path={APP_ROUTES.FILL_FEEDBACK}
          element={<FillFeedback />}
        ></Route>
        <Route
          element={
            <ProtectedRoute
              allowedRoles={[ROLE.INSTRUCTOR, ROLE.STUDIO_ADMIN]}
            />
          }
        ></Route>
        <Route
          path={APP_ROUTES.FEEDBACK_LISTING_DETAILS}
          element={<FeedBackDetails />}
        ></Route>
        <Route
          element={
            <ProtectedRoute
              allowedRoles={[ROLE.INSTRUCTOR, ROLE.STUDIO_ADMIN, ROLE.STUDENT]}
            />
          }
        >
          <Route
            path={APP_ROUTES.CREATE_FEEDBACK}
            element={<CreateFeedback />}
          ></Route>
        </Route>
        <Route
          element={
            <ProtectedRoute
              allowedRoles={[ROLE.INSTRUCTOR, ROLE.STUDIO_ADMIN, ROLE.STUDENT]}
            />
          }
        >
          <Route
            path={APP_ROUTES.FEEDBACK_CHART}
            element={<FeedBackChart />}
          ></Route>
        </Route>
        <Route element={<ProtectedRoute allowedRoles={[ROLE.ADMIN]} />}>
          <Route
            path={APP_ROUTES.ROUTE_TRAININGCENTER}
            element={<TraingCenter />}
          />
        </Route>
        <Route
          element={
            <ProtectedRoute
              allowedRoles={[ROLE.INSTRUCTOR, ROLE.STUDIO_ADMIN, ROLE.STUDENT]}
            />
          }
        >
          <Route path={APP_ROUTES.ROUTE_STUDENT} element={<Student />} />
        </Route>
        <Route element={<ProtectedRoute allowedRoles={[ROLE.STUDIO_ADMIN]} />}>
          <Route path={APP_ROUTES.ROUTE_INSTRUCTOR} element={<Instructor />} />
        </Route>
        <Route element={<ProtectedRoute allowedRoles={[ROLE.STUDIO_ADMIN]} />}>
          <Route
            path={APP_ROUTES.ROUTE_TRAININGCENTER_ADMIN}
            element={<TCAdmin />}
          />
          <Route path={APP_ROUTES.ADD_TC_ADMIN} element={<AddTCAdminForm />} />
        </Route>
        <Route element={<ProtectedRoute allowedRoles={[ROLE.ADMIN]} />}>
          <Route path={APP_ROUTES.REPORTS} element={<Reports />} />
        </Route>
        <Route
          element={
            <ProtectedRoute
              allowedRoles={[ROLE.ADMIN, ROLE.INSTRUCTOR, ROLE.STUDIO_ADMIN]}
            />
          }
        >
          <Route
            path={APP_ROUTES.FEEDBACK_TEMPLATE_LISTING}
            element={<FeedbackTemplate />}
          />
        </Route>
        <Route
          element={
            <ProtectedRoute
              allowedRoles={[ROLE.ADMIN, ROLE.INSTRUCTOR, ROLE.STUDIO_ADMIN]}
            />
          }
        >
          <Route
            path={APP_ROUTES.CONTACTSUPPORT}
            element={<CONTACTSUPPORT />}
          ></Route>
        </Route>
        {/* Add protected routes for support */}
        {/* <Route path={APP_ROUTES.MONITORING} element={<MONITORING />}></Route> */}
        {/* </Route> */}
      </Routes>
    </>
  );
};
export default MainRoutes;
